import React, { useState } from "react";
import { useCmsSection } from "@/hooks/useCmsContent";
import { useCmsList } from "@/hooks/useCmsList";
import Editable from "@/components/cms/Editable";
import styles from './social.module.css';

interface SocialLink {
    id?: number;
    platform: string;
    url: string;
    icon: string;
    background: string;
}

interface YouTubeVideo {
    id?: number;
    label: string;
    embed_url: string;
}

const DEFAULT_VIDEOS: YouTubeVideo[] = [
    { label: 'Fueling Discovery', embed_url: 'https://www.youtube.com/embed/6RQ280IV4Dc' },
    { label: 'Kwik Fill USA', embed_url: 'https://www.youtube.com/embed/fHhMcb_3IZQ' },
    { label: 'Gift Card', embed_url: 'https://www.youtube.com/embed/NuOC9e2C6dw' },
    { label: 'Fleet Fueling', embed_url: 'https://www.youtube.com/embed/vU-8eVy3FY8' },
];

const DEFAULT_LINKS: SocialLink[] = [
    { platform: 'facebook', url: 'https://www.facebook.com/KwikFill', icon: 'social_facebook.svg', background: 'social_facebook-background.png' },
    { platform: 'youtube', url: 'https://www.youtube.com/channel/UCSomUa_mrjBh9ilzEQIvcag', icon: 'social_youtube.svg', background: 'social_youtube-background.png' },
    { platform: 'instagram', url: 'https://www.instagram.com/kwikfill/', icon: 'social_instagram.svg', background: 'social_instagram-background.png' },
    { platform: 'twitter', url: 'https://twitter.com/kwikfill', icon: 'social_twitter.svg', background: 'social_twitter-background.png' },
];

export default function HomeSocial() {
    const { fields } = useCmsSection('home', 'social', { title: '@KwikFill' });
    const { items: videos } = useCmsList<YouTubeVideo>('social-youtube-videos');
    const { items: links } = useCmsList<SocialLink>('social-links');

    const [selectedTab, setSelectedTab] = useState(0);

    const displayVideos = videos.length > 0 ? videos : DEFAULT_VIDEOS;
    const displayLinks = links.length > 0 ? links : DEFAULT_LINKS;

    const currentVideo = displayVideos[selectedTab] || displayVideos[0];

    return (
        <div className={styles.container}>
            <div>
                {displayVideos.map((video, i) => (
                    <div
                        key={i}
                        onClick={() => setSelectedTab(i)}
                        className={[styles.pill, selectedTab === i ? styles.pill_selected : ''].join(' ')}
                    >
                        {video.label}
                    </div>
                ))}
            </div>

            <div>
                <div className={styles.iframe_container}>
                    <iframe
                        className={styles.iframe}
                        src={currentVideo?.embed_url}
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </div>
            </div>

            <div>
                <Editable page="home" section="social" field="title" value={fields.title}>
                    <div className={styles.social_title}>{fields.title}</div>
                </Editable>

                <div className={styles.social_container}>
                    {displayLinks.map((link, i) => (
                        <div
                            key={i}
                            onClick={() => window.open(link.url)}
                            className={styles.social_square}
                            style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/home/${link.background})` }}
                        >
                            <img
                                src={`${process.env.PUBLIC_URL}/assets/home/${link.icon}`}
                                className={styles.social_icon}
                                alt={link.platform}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
